import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, KeyRound, Bell, Globe, Mail } from "lucide-react";

export default function AdminSettings({ admin }) {
  const items = [
    {
      icon: ShieldCheck,
      title: "Account",
      desc: `Signed in as ${admin?.email || "admin"}.`,
      action: "Manage",
    },
    {
      icon: KeyRound,
      title: "Security",
      desc: "Update your password and enable two-factor auth.",
      action: "Configure",
    },
    {
      icon: Bell,
      title: "Notifications",
      desc: "Email digest and pending approval alerts.",
      action: "Customize",
    },
    {
      icon: Globe,
      title: "Localization",
      desc: "Date format, timezone, and language preferences.",
      action: "Customize",
    },
    {
      icon: Mail,
      title: "Email Templates",
      desc: "Application acknowledgement and approval emails.",
      action: "Edit",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {items.map((it, idx) => (
        <motion.div
          key={it.title}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.05 }}
          whileHover={{ y: -3 }}
          className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 flex items-start gap-4 hover:shadow-md transition-shadow"
        >
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#1E3A8A]/10 to-[#C49A3A]/10 flex items-center justify-center">
            <it.icon className="w-5 h-5 text-cct-blue" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display text-lg font-semibold text-slate-900">
              {it.title}
            </div>
            <div className="text-sm text-slate-500">{it.desc}</div>
          </div>
          <button
            disabled
            className="text-xs font-semibold text-cct-blue/70 cursor-not-allowed"
          >
            {it.action}
          </button>
        </motion.div>
      ))}
      <div className="md:col-span-2 bg-gradient-to-br from-[#1E3A8A]/5 to-[#C49A3A]/5 border border-dashed border-slate-300 rounded-2xl p-6 text-center">
        <p className="text-sm text-slate-600">
          More settings coming soon. Have a feature request? Drop us an email at{" "}
          <a
            className="text-cct-blue font-semibold hover:underline"
            href="mailto:info@cambridgecollegebc.com"
          >
            info@cambridgecollegebc.com
          </a>
        </p>
      </div>
    </div>
  );
}
